export const CODE_DIGIT_NUMBER = 6;
